'use strict';

var processInclude = require('base/util');

window.initMap = function () {
    processInclude(require('./services/google'));
};

window.initStoreLocator = function () {
    processInclude(require('./services/google'));
    processInclude(require('./storeLocator/storeLocatorMap'));
};
